<template>
  <LoaderComponent :value="promise" theme="default">
    <component
      :is="tag"
      :value="valueComp"
      v-bind="$attrs"
      ref="webcomponent"
      :fetch-url="fetchUrl"
      v-on="{
        ...filteredListeners,
        'webcomponent:update': $ev => update($ev),
      }"
    ></component>
  </LoaderComponent>
</template>

<script>
import { LoadScript, WaitUntil } from '../utils'
import { path } from 'ramda'
import { LoaderComponent } from 'vue-elder-loader'

export default {
  props: {
    value: null,
    source: {
      type: String,
    },
    tag: {
      type: String,
    },
    customFetch: {
      type: String,
    },
    parentIndex: Number,
    data: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      promise: null,
    }
  },
  computed: {
    filteredListeners() {
      let listeners = this.$listeners
      delete listeners.input
      return listeners
    },
    fetchUrl() {
      if (!this.customFetch) return ''

      const url = this.customFetch
      let params = url.match(/\{(.*?)\}/gi) || []
      return params.reduce((accumulator, current) => {
        let key = current.replace(/{|}/g, '').replace(/\[\]/g, this.parentIndex)

        return accumulator.replace(current, path(key.split('.'), this.data))
      }, url)
    },
    valueComp() {
      return JSON.stringify(this.value)
    },
  },
  methods: {
    update(event) {
      let value = JSON.parse(JSON.stringify(event.detail))
      this.$emit('input', value)
    },
  },
  mounted() {
    LoadScript(this.source, { type: 'module' })
    this.promise = WaitUntil(() => document.querySelector(`script[src="${this.source}"]`))
  },
  components: {
    LoaderComponent,
  },
}
</script>

<style lang="scss" scoped></style>
